// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum IotModel {
    Reliagate = 0,
    Compulab_IOTG_IMX8PLUS = 1,
}
export default IotModel;
